import '@emotion/react';

export const defaultCssVariables = {
    font: {
        family: {
            title: "'Roboto', sans-serif",
            text: "'Roboto', sans-serif",
            button: "'Roboto', sans-serif",
        },
        size: {
            huge: '24px',
            large: '20px',
            medium: '16px',
            normal: '14px',
            small: '12px',
            tiny: '10px',
        },
        weight: {
            light: 300,
            regular: 400,
            medium: 500,
            bold: 600,
        },
        lineHeight: {
            medium: '20px',
            normal: '18px',
        },
    },
    color: {
        backgroundMain: '#F2F2F2',
        backgroundBar: '#21232F',
        backgroundMainButton: '#21232F',
        borderMainButton: '#000000',
        textMainButton: '#FFF',
        textMain: '#333333',
        textSecondary: '#999999',
        borderSecondaryButton: '#F3F3F3',
        backgroundSecondaryButton: '#FFFFFF',
        textSecondaryButton: '#424242',
        separator: 'rgba(126, 131, 137, 0.2)',
        slate100: '#21232F',
        slate200: '#2A2D39',
        slate300: '#313443',
        black: '#333333',
        black300: '#999999',
        black200: '#666666',
        white100: '#FFFFFF',
        white200: '#FBFBFB',
        grey100: '#F6F6F6',
        grey200: '#ECECEC',
        grey300: '#F3F3F3',
        grey400: '#CBCBCB',
        grey500: '#B7B7B7',
        palePink: '#FFD5D5',
        palePink100: '#feebeb',
        emerald: '#3EC978',
        bloodyMary: '#F45959',
        mint: '#7EB4AF',
    },
    radius: {
        none: '0px',
        s: '4px',
        sm: '6px',
        default: '8px',
        md: '10px',
        lg: '12px',
        xl: '14px',
    },
    spacing: {
        1: '5px',
        2: '10px',
        3: '15px',
        4: '20px',
        5: '25px',
        6: '30px',
        7: '35px',
        8: '40px',
        9: '45px',
        10: '50px',
    },
    background:
        'https://images.unsplash.com/photo-1663210253953-4e647b573003?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1965&q=80s',
};

export type BaseTheme = typeof defaultCssVariables;

type TextProperties = {
    color: string;
    fontFamily: string;
    fontSize: string;
    lineHeight: string;
    weight: number;
};

export type FeaturesTheme = {
    buttonMain: {
        background: string;
        borderRadius: string;
        fontSize: string;
        borderColor: string;
        fontColor: string;
    };
    buttonSecondary: {
        background: string;
        borderRadius: string;
        fontSize: string;
        borderColor: string;
        fontColor: string;
    };
    title: TextProperties;
    text: TextProperties;
};

export type ThemeType = {
    base: BaseTheme;
    feature: FeaturesTheme;
};

declare module '@emotion/react' {
    // eslint-disable-next-line @typescript-eslint/no-empty-interface
    export interface Theme extends ThemeType {}
}
